export default __webpack_public_path__ + "static/media/demo-doodle.2a780e58.png";